import { RootState } from '@store/store';
import { useSelector } from 'react-redux';

function useIsHotSelected(): boolean {
    const { orderLines } = useSelector((state: RootState) => state.item);
    const allOptions = orderLines
        .map((line) => [...line.defaultOptions, ...line.personalOptions])
        .flat()
        .map((it) => it.options)
        .flat();

    return !!allOptions.find((it) => it.optionName === 'HOT');
}

export default useIsHotSelected;
